import { render, staticRenderFns } from "./PassVaccineIntroduction.vue?vue&type=template&id=d239434c&scoped=true&"
import script from "./PassVaccineIntroduction.vue?vue&type=script&lang=ts&"
export * from "./PassVaccineIntroduction.vue?vue&type=script&lang=ts&"
import style0 from "./PassVaccineIntroduction.vue?vue&type=style&index=0&id=d239434c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d239434c",
  null
  
)

export default component.exports